const AfarmLogo = () => {
  return (
    <div className="shadow-md shadow-black text-green-600 bg-white text-[1.7rem] w-[200px] h-[200px] object-contain flex flex-col items-center border-green-600 justify-center text-center border-[0.7rem] rounded-full font-bold">
      <div>
        <p>BILJNA</p>
        <p>APOTEKA</p>
        <p>A-FARM</p>
      </div>
    </div>
  );
};

export default AfarmLogo;
